import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Mask } from 'antd-mobile';
const MaskIndex = (props) => {
    const { children, visible, opacity = 'default', ...others } = props;
    return (_jsx(Mask, { visible: visible, opacity: opacity, ...others, children: children }));
};
export default MaskIndex;
//# sourceMappingURL=index.js.map